import { combineReducers } from '@reduxjs/toolkit';
import * as types from '../types';
import { checkoutInitialState, createCheckoutSlice } from './checkout';
import { cartActions, cartInitialState, cartReducer } from './verizonCart';

const initialState: types.VerizonShopState = {
  cart: cartInitialState,
  checkout: checkoutInitialState,
};

const name = 'verizonShop' as const;

const { actions: checkoutActions, reducer: checkoutReducer } = createCheckoutSlice(name);

export const verizonShopActions = {
  ...cartActions,
  ...checkoutActions,
};
export const verizonShopReducer = combineReducers({
  cart: cartReducer,
  checkout: checkoutReducer,
});
export const verizonShopInitialState = { [name]: initialState };
